import Mustache from "mustache";
import Search, {ViewFilterType,  SearchInitConfig, SearchClientConfig } from "../search";
import Utility from '../../classes/utility';
import StaffDirectoryCustomRender from "../customRenders/staff-directory-search-custom-render";

const searchParentTemplate = require('/src/templates/components/search/staff-directory/search-parent-tpl').default;
const itemParentTemplate = require('/src/templates/components/search/staff-directory/item-parent-tpl').default;
const itemTemplateList = require('/src/templates/components/search/staff-directory/staff-directory-search--list').default;
const itemTemplateGrid = require('/src/templates/components/search/staff-directory/staff-directory-search--grid').default;
const itemEmptyTemplate = require('/src/templates/components/search/alumni-business/item-empty-tpl').default;
class StaffDirectorySearch extends Search {
    private landingSearchElement: HTMLElement;
    private landingSearchResults: HTMLElement;
    private landingSearchBox: HTMLElement;
    constructor(landingSearchElement: HTMLElement, clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        clientConfig.hitsPerPage = 100;
        super(clientConfig, initConfig);
        this.landingSearchElement = landingSearchElement;
        this.landingSearchResults = document.querySelector(`.${landingSearchElement.dataset.id}-results`)
        this.renderParent();
        this.initConfigOverride();
    }

    private initConfigOverride() {
        this.initConfig = {
            searchBoxId: this.landingSearchBox.id,
            resultContainerId: "landing-search-hits",
            queryName: "aq",
            allowEmptyQuery: true,
            showOnLoad: true,
            activeTemplate: "grid",
            textboxPlaceholder: "Search Staff Directory...",
            templates: {
                list: itemTemplateList,
                grid: itemTemplateGrid,
                empty: itemEmptyTemplate
            },    
            buttonClassTargets: {
                grid: "grid-view",
                list: "list-view",
            },
            cssClasses: { root: "list-unstyled row staff-directory-main-container"},
            customRender: StaffDirectoryCustomRender.customRender
        };
    }

    private renderParent() {
        const self = this;
        self.landingSearchElement.innerHTML = Mustache.render(searchParentTemplate, {
            id: self.landingSearchElement.dataset.id
        });
        self.landingSearchResults.innerHTML = Mustache.render(itemParentTemplate, {
            id: self.landingSearchElement.dataset.id
        });
        self.landingSearchBox = self.landingSearchElement.querySelector(".landing-search-box");
    }

    override onLoad(facets: Array<any>) {
        this.onLoadFacets(facets);
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
    }

    init() {
        super.init();
        // get query in URL - if set
        let query = Utility.getUrlParameter(this.initConfig.queryName);
        // trigger filters
        this.lazyloading = true;
        // trigger search on page load query
        this.onloadGetParameters();
        if (query) {
            this.search.helper.setQuery(query)
            this.search.helper.search();
        }
    }

    private onLoadViewFilters() {
        let self = this;
        self.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `${self.landingSearchElement.dataset.id}-clearFilters`,
            cssClasses: {
                button: "btn btn-link text-white text-decoration-none clear-filters"
            }
        });
    }

    private onLoadFacets(facets: Array<any>) {
        let self = this;
        facets.forEach(facet => {
            self.addFacet({
                field: facet.key,
                value: facet.value,
            });
        });
    }

    private onLoadViewUpdates() {
        let self = this;

        self.customSearch = function () {
            let clearFiltersBtn = document.getElementById(`${self.landingSearchElement.dataset.id}-clearFilters`) as HTMLDivElement;

            if (clearFiltersBtn) {
                // display clear filters text
                clearFiltersBtn.classList.remove("d-none");
                clearFiltersBtn.classList.add("d-inline-block");
            } else {
                clearFiltersBtn.classList.add("d-none");
                clearFiltersBtn.classList.remove("d-inline-block");
                self.setSearchBoxValue("");
            }
        }
    }
    private onLoadSearch() {
        let self = this;
        // get the algolia search box
        if (self.landingSearchBox) {
            // init algolia
            self.init();
        }
    }

    onloadGetParameters()
    {
        let urlSearchParams = new URLSearchParams(window.location.search);
        const self = this;
        if(urlSearchParams != null)
        {
            if(urlSearchParams.has("filtercategory"))
            {
                var filterSubCategory = urlSearchParams.get('filtercategory');
                if(filterSubCategory !== null){
                    self.addFacet({
                        field: "subCategory",
                        value: filterSubCategory,
                    });
                }
            }
        }
    }
}
export default StaffDirectorySearch;